import { consentApiFactory } from 'services/api/consentApi/consentApiFactory';
import { createApiHook } from '../hooks';

export const useConsentApi = createApiHook(consentApiFactory);
